import { useI18n } from "../i18n.jsx";

export default function LanguageToggle({ className = "" }) {
  const { locale, setLocale, t } = useI18n();
  const classNames = ["language-toggle", className].filter(Boolean).join(" ");

  return (
    <div className={classNames} role="group" aria-label={t("locale.label")}>
      <button
        className={locale === "ja" ? "is-active" : ""}
        type="button"
        aria-pressed={locale === "ja"}
        aria-label={t("locale.switchToJapanese")}
        onClick={() => setLocale("ja")}
      >
        {t("locale.japanese")}
      </button>
      <button
        className={locale === "en" ? "is-active" : ""}
        type="button"
        aria-pressed={locale === "en"}
        aria-label={t("locale.switchToEnglish")}
        onClick={() => setLocale("en")}
      >
        {t("locale.english")}
      </button>
    </div>
  );
}
